import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { IfVariantSelectModule, IfBillingFormCcExpiryInputModule, IfTranslationModule, AsyncImageModule, BillingFormCheckboxModule, BillingFormCountrySelectModule, BillingFormInputModule, BillingFormMobileInputModule, BillingFormModule, BillingFormProductVariantSelectModule, BillingFormSelectModule, BillingFormStateSelectModule, CountdownTimerModule, ExitDialogModule, IfBillingFormMobileFlagInputModule, IfPopupButtonModule, IfProductFaqModule, IfPurchaseNotificationsModule, PageViewModule, IfQueryControlsModule, IfStickyModule, IfTestimonialsModule, IfScrollToModule } from 'ngx-intellforce-billing';
import { TermsComponent } from './terms/terms.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { CcpaComponent } from './ccpa/ccpa.component';
import { ImpressumComponent } from './impressum/impressum.component';

@NgModule({
  declarations: [
    AppComponent,
      TermsComponent,
      PrivacyComponent,
      CcpaComponent,
      ImpressumComponent
   ],
  imports: [
    BrowserModule,
    BillingFormModule,
    BillingFormMobileInputModule,
    BillingFormInputModule,
    BillingFormSelectModule,
    BillingFormCountrySelectModule,
    BillingFormCheckboxModule,
    BillingFormStateSelectModule,
    BillingFormProductVariantSelectModule,
    CountdownTimerModule,
    AsyncImageModule,
    ExitDialogModule,
    PageViewModule,
    IfProductFaqModule,
    IfPurchaseNotificationsModule,
    IfPopupButtonModule,
    IfBillingFormMobileFlagInputModule,
    IfBillingFormCcExpiryInputModule,
    IfTranslationModule,
    IfQueryControlsModule,
    IfStickyModule,
    IfTestimonialsModule,
    IfScrollToModule,
    IfVariantSelectModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
